import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import cn from 'classnames';
import { Player } from '@lottiefiles/react-lottie-player';

import styles from './real-estate-intro.module.css';
import {
  Button,
  Container,
  ContainerFluid,
  Htag,
  HtagVariant,
} from '../../components';

export default function RealEstateIntro() {
  return (
    <section className={styles.intro}>
      <ContainerFluid>
        <Container>
          <div className={styles.intro_inner}>
            <div className={styles.intro_block}>
              <Htag
                tag="h3"
                variant={HtagVariant.h3}
                className={styles.intro_title}
              >
                REAL ESTATE
              </Htag>
              <Htag
                tag="h5"
                variant={HtagVariant.h5}
                className={styles.intro_text}
              >
                We develop Real Estate Software solutions for sellers, buyers,
                landlords, tenants and realtors.
              </Htag>
              <Link href="/#works">
                <a>
                  <Button appearance="primary">Our works</Button>
                </a>
              </Link>
            </div>
          </div>
          <Player
            className={styles.intro_image}
            src="https://assets9.lottiefiles.com/private_files/lf30_a3oeesnn.json"
            background="transparent"
            speed={1}
            loop
            autoplay
          />
          <div className={cn(styles.intro_image, styles.image_background)}>
            <Image
              alt="intro bg"
              src="/real-estate/intro/bg.svg"
              width={1250}
              height={250}
            />
          </div>
        </Container>
      </ContainerFluid>
    </section>
  );
}
